import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { useContent } from "@/context/ContentContext";

const STATS = [
  { value: "350+", label: "Momen Terdekorasi" },
  { value: "100%", label: "Kepuasan Klien" },
  { value: "5+ Thn", label: "Pengalaman" },
];

const scrollTo = (href) => {
  const el = document.querySelector(href);
  if (el) el.scrollIntoView({ behavior: "smooth" });
};

export const Hero = () => {
  const { content } = useContent();
  const h = content.hero || {};
  const stats = h.stats && h.stats.length ? h.stats : STATS;
  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center overflow-hidden"
      data-testid="hero-section"
    >
      <div className="absolute inset-0">
        <img
          src={h.image || "https://images.unsplash.com/photo-1786125493218-f9933f67a0f1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHxfYXJjaHxlbnwwfHx8fDE3OTA1NTYzNTZ8MA&ixlib=rb-4.1.0&q=85"}
          alt="Dekorasi pernikahan mewah"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#1C1917]/85 via-[#1C1917]/55 to-transparent" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-5 lg:px-8 w-full pt-28 pb-16">
        <div className="max-w-2xl">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="font-mono text-xs tracking-[0.3em] uppercase text-[#E8D9BD] mb-6"
          >
            {h.badge || "Ascarya Dekorasi — Est. 2019"}
          </motion.p>

          <motion.h1
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.2 }}
            className="font-serif text-4xl sm:text-5xl lg:text-6xl font-semibold text-white tracking-tight leading-[1.05]"
          >
            {h.line1 || "Wujudkan Momen Istimewa Anda"}
            <span className="block italic font-normal text-[#E8D9BD] mt-2">
              {h.line2 || "Dengan Dekorasi yang Berkesan"}
            </span>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.35 }}
            className="mt-7 text-base sm:text-lg text-white/80 leading-relaxed max-w-xl"
          >
            {h.subtitle || "Layanan dekorasi pernikahan, lamaran & event eksklusif dengan sentuhan artistik, mewah, dan dipersonalisasi sesuai cerita cinta Anda."}
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.5 }}
            className="mt-9 flex flex-col sm:flex-row gap-4"
          >
            <button
              onClick={() => scrollTo("#booking")}
              data-testid="hero-primary-booking-button"
              className="group inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full bg-[#C5A059] text-white text-xs font-semibold tracking-widest uppercase hover:bg-[#A8833E] transition-all shadow-lg shadow-[#C5A059]/30"
            >
              Booking Sekarang
              <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </button>
            <button
              onClick={() => scrollTo("#paket")}
              data-testid="hero-secondary-paket-button"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full border border-white/40 text-white text-xs font-semibold tracking-widest uppercase hover:bg-white hover:text-[#1C1917] transition-all"
            >
              Lihat Paket
            </button>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.65 }}
            className="mt-14 flex flex-wrap gap-10"
          >
            {stats.map((s) => (
              <div key={s.label}>
                <div className="font-serif text-3xl text-white font-semibold">
                  {s.value}
                </div>
                <div className="text-[11px] tracking-widest uppercase text-white/60 mt-1">
                  {s.label}
                </div>
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};
